module.exports = __webpack_public_path__ + "static/media/vendedor-loja.f0fb01f1.jpg";